import NotFound from "../../assets/images/not_found.png";

const EmptyList = ({ message }) => {
  return (
    <>
      <div className="flex flex-col items-center">
        <div>
          <img src={NotFound} className="w-[150px]" />
        </div>
        <div>{message}</div>
      </div>
    </>
  );
};

export default EmptyList;
